import { NgModule, Injector, Provider, APP_INITIALIZER } from '@angular/core';
import { HttpModule, JsonpModule, Http, ConnectionBackend, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend, Headers } from '@angular/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileSelectDirective } from 'ng2-file-upload/ng2-file-upload';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { MainComponent } from './main.component';
import { Configuration } from '../app.constants';
import { mainRouting, appRoutingProviders } from './main.routes';
import { AdalHttp } from '../services/adal.http.service';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from '../services/appsettings.service';
import { CanActivateViaAuthGuard } from '../services/authguard.service';
import { ProgressBarComponent } from '../common/progressbar/progressbar.component'
import { ProgressBarService } from '../services/progressbar.service'
import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import { BusyModule, BusyConfig } from 'angular2-busy';

import { SystemDetailsComponent } from './systemDetailsRetriever/system-details-retriever.component';
import { SystemDetailsRetriever } from './systemDetailsRetriever/system-details-retriever.service';
import { AccessManagementComponent } from './accessManagement/access-management.component';
import { PortalAdmin } from './portalAdmin/portaladmin.component';
import { SystemTypeRegistrationComponent } from './systemTypeManagement/system-type-registration.component';
import { SystemTypeRegistration } from './systemTypeManagement/system-type-registration.service'
import { AccessManagementService } from "./accessManagement/access-management.service";
import { SentienceDeviceManagerComponent } from './sentienceDeviceManager/sentience-device-manager.component';
import { SentienceDeviceManager } from './sentienceDeviceManager/sentience-device-manager.service';
import { PortalAdminService } from './portalAdmin/portaladmin.service';
import { NotificationComponent } from "../notification/notification.component"
import { NotificationService } from "../services/notification.service";
import { ModelTypeRegistrationComponent } from "./modelTypeRegistration/model-type-registration.component";
import { ModelTypeRegistrationService } from "./modelTypeRegistration/model-type-registration.service";
import { AnnotationStreamManagementComponent } from './annotationStreamManagement/annotation-stream-management.component';
import { AnnotationStreamManagement } from './annotationStreamManagement/annotation-stream-management.service';
import { AnnotationStreamManagementComponentV2 } from './annotationStreamManagementV2/annotation-stream-management.component';
import { AnnotationStreamManagementV2 } from './annotationStreamManagementV2/annotation-stream-management.service';
import { SystemHealthComponent } from './systemHealthRetriever/system-health-retriever.component';
import { SystemHealthRetriever } from './systemHealthRetriever/system-health-retriever.service';
import { SystemSeviceManagementComponent } from './SystemServicesManager/system-service.component';
import { SystemServicesManager } from './SystemServicesManager/system-service.service';
import { CustomApplicationCreatorComponent } from "./customapplicationcreation/custom-application-creation.component";
import { CustomApplicationCreator } from './customapplicationcreation/custom-application-creation.service';
import { UserManagementComponent } from './userManagement/user-management.component'
import { UserManagementService } from './userManagement/user-management.service'
import { OnboardingUserComponent } from './onboardingUserForgerock/onboard-user.component'
import { OnboardingUserService } from './onboardingUserForgerock/onboard-user.service'
import { TenantDetailsRemoverService } from './tenant-details-remover/tenant-details-remover.service';
import { TenantDetailsRemoverComponent } from './tenant-details-remover/tenant-details-remover.component';
import { TenantRetrieverService } from '../services/tenant-Retriever.service';
import { ForgerockUriManagementComponent } from "./forgerockUriManagement/forgerock-uri-management.component";
import { ForgeRockUriManagementService } from "./forgerockUriManagement/forgerock-uri-management-service";
import { DeviceCACertificateManagementComponent } from "./DeviceCACertificateManagement/manage-device-ca-certificates-component";
import { DeviceCACertificateManagementService } from "./DeviceCACertificateManagement/manage-device-ca-certificates-service";
import { finegrainedComponent } from './FineGrainedAuthorization/finegrained.component';
import { finegrainedService } from './FineGrainedAuthorization/finegrained.service';


@NgModule({
    imports: [
        mainRouting,
        HttpModule,
        JsonpModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        BusyModule.forRoot(new BusyConfig({
            message: "",
            template: ``,
            backdrop: true,
            delay: 200,
            minDuration: 600
        }))
    ],

    declarations: [
        MainComponent,
        SystemDetailsComponent,
        SystemTypeRegistrationComponent,
        AccessManagementComponent,
        SentienceDeviceManagerComponent,
        PortalAdmin,
        NotificationComponent,
        ModelTypeRegistrationComponent,
        AnnotationStreamManagementComponent,
        AnnotationStreamManagementComponentV2,
        SystemHealthComponent,
        CustomApplicationCreatorComponent,
        SystemSeviceManagementComponent,
        UserManagementComponent,
        TenantDetailsRemoverComponent,
        OnboardingUserComponent, 
        ForgerockUriManagementComponent,
        DeviceCACertificateManagementComponent,
        finegrainedComponent
    ],

    providers: [
        appRoutingProviders,
        Configuration,
        AdalService,
        CanActivateViaAuthGuard,
        {
            provide: AdalHttp, useFactory: (connectionBackend: XHRBackend, defaultOptions: RequestOptions, authService: AdalService, adConfigService: AppSettingsService, progressBarService: ProgressBarService) => {
                return new AdalHttp(connectionBackend, defaultOptions, authService, adConfigService, progressBarService);
            }, deps: [XHRBackend, RequestOptions, AdalService, AppSettingsService, ProgressBarService]
        },
        SystemDetailsRetriever,
        SystemTypeRegistration,
        AccessManagementService,
        SentienceDeviceManager,
        PortalAdminService,
        NotificationService,
        ModelTypeRegistrationService,
        AnnotationStreamManagement,
        AnnotationStreamManagementV2,
        SystemHealthRetriever,
        CustomApplicationCreator,
        SystemServicesManager,
        UserManagementService,
        OnboardingUserService,
        TenantDetailsRemoverService,
        TenantRetrieverService,
        ForgeRockUriManagementService,
        DeviceCACertificateManagementService,
        finegrainedService
    ],

    bootstrap: [MainComponent]
})

export class MainModule {
}




/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/main.module.ts
 **/